import { RouteObject } from 'react-router-dom';

import InstructionsPage from 'pages/Instructions/InstructionsPage';

export const instructionsRoutes: RouteObject[] = [
  {
    path: '/instructions',
    element: <InstructionsPage />,
  },
];
